import './locales';
import './styles/globals.css';

import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppProviders } from './providers';
import { ErrorBoundary } from '@/core/error-handling/ErrorBoundary';
import { SessionBootstrap } from '@/core/auth/SessionBootstrap';
import { ToastContainer } from '@/core/notifications';
import { AppRouter } from '@/navigation/router';
import { initSentry } from './lib/sentry';
import { MoneyRealtimeInvalidationSync } from '@/features/money/realtime/MoneyRealtimeInvalidationSync';

// Phase 6 — Sentry browser bootstrap. Gated on VITE_SENTRY_DSN +
// VITE_APP_ENV !== 'development'. See lib/sentry.ts for the full
// gating contract.
initSentry();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <AppProviders>
        <ToastContainer />
        <SessionBootstrap>
          <MoneyRealtimeInvalidationSync />
          <AppRouter />
        </SessionBootstrap>
      </AppProviders>
    </ErrorBoundary>
  </React.StrictMode>
);
